module.exports = __webpack_public_path__ + "img/BELUM_LUNAS_WATERMARK.f0a9a39c.svg";